import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=1a80390b&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=ts&"
export * from "./Loader.vue?vue&type=script&lang=ts&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=1a80390b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a80390b",
  null
  
)

export default component.exports